export default __webpack_public_path__ + "static/fa-brands-400-4d95cd55e78c4831155dfc0756b54c54.woff2";